<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'landing-page-wa-autosender-content'" :loading="!formReady">
            <template v-slot:title-bar v-if="formReady">
                <div class="header-top bg-transparent border-0">
                    <div class="header-top--inner w-limit">
                        <div class="header-top--left">
                            <div class="header-item">
                                <img src="../../../assets/icons/back-blue.svg" alt="" @click="back" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>

            <template v-slot:content v-if="formReady">
                <div class="wa-autosender-content f-14 f-c-black f-regular">
                    <div class="content-title f-16 f-bold p-t-16">
                        <svg
                            width="100"
                            height="100"
                            viewBox="0 0 100 100"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M50.2002 0.000206295C22.9002 0.000206295 0.650245 22.2502 0.650245 49.5502C0.650245 58.3002 2.95024 66.8002 7.25024 74.3002L0.250244 100L26.5002 93.1002C33.7502 97.0502 41.9002 99.1502 50.2002 99.1502C77.5002 99.1502 99.7502 76.9002 99.7502 49.6002C99.7502 36.3502 94.6002 23.9002 85.2502 14.5502C80.6662 9.91983 75.2061 6.24854 69.1884 3.75046C63.1707 1.25238 56.7158 -0.0224921 50.2002 0.000206295ZM50.2502 8.35021C61.2502 8.35021 71.5502 12.6502 79.3502 20.4502C83.1783 24.277 86.2132 28.8218 88.281 33.824C90.3489 38.8262 91.4089 44.1874 91.4002 49.6002C91.4002 72.3002 72.9002 90.7502 50.2002 90.7502C42.8002 90.7502 35.5502 88.8002 29.2502 85.0002L27.7502 84.1502L12.1502 88.2502L16.3002 73.0502L15.3002 71.4502C11.1699 64.8935 8.9853 57.2993 9.00024 49.5502C9.05024 26.8502 27.5002 8.35021 50.2502 8.35021ZM32.6502 26.6502C31.8502 26.6502 30.5002 26.9502 29.3502 28.2002C28.2502 29.4502 25.0002 32.5002 25.0002 38.5502C25.0002 44.6502 29.4502 50.5002 30.0002 51.3502C30.7002 52.2002 38.8002 64.7002 51.2502 70.0002C54.2002 71.3502 56.5002 72.1002 58.3002 72.6502C61.2502 73.6002 63.9502 73.4502 66.1002 73.1502C68.5002 72.8002 73.4002 70.1502 74.4502 67.2502C75.5002 64.3502 75.5002 61.9002 75.2002 61.3502C74.8502 60.8502 74.0502 60.5502 72.8002 60.0002C71.5502 59.3002 65.4502 56.3002 64.3502 55.9002C63.2002 55.5002 62.5002 55.3002 61.5502 56.5002C60.7502 57.7502 58.3502 60.5502 57.6502 61.3502C56.9002 62.2002 56.2002 62.3002 55.0002 61.7002C53.7002 61.0502 49.7002 59.7502 45.0002 55.5502C41.3002 52.2502 38.8502 48.2002 38.1002 46.9502C37.5002 45.7502 38.0502 45.0002 38.6502 44.4502C39.2002 43.9002 40.0002 43.0002 40.5002 42.2502C41.1502 41.5502 41.3502 41.0002 41.7502 40.2002C42.1502 39.3502 41.9502 38.6502 41.6502 38.0502C41.3502 37.5002 38.8502 31.3002 37.8002 28.8502C36.8002 26.4502 35.8002 26.7502 35.0002 26.7002C34.3002 26.7002 33.5002 26.6502 32.6502 26.6502Z"
                                fill="#24A148"
                            />
                        </svg>
                        <div class="p-t-20">
                            <label>Whatsapp Autosender & Whatsapp Blast</label>
                        </div>
                    </div>
                    <div class="fitur p-x-20 p-t-20">
                        <ul class="p-l-20">
                            <li>
                                Kirim pesan pemberitahuan atau mengirim pesan ke banyak nomor sekaligus, secara otomatis
                                tanpa perlu membuka aplikasi WhatsApp
                            </li>
                            <li>Kirim pesan sekarang atau jadwalkan untuk nanti.</li>
                            <li>Satu nomor bisa digunakan banyak outlet.</li>
                        </ul>
                    </div>
                    <div class="biaya p-x-20">
                        <div>
                            <p class="m-d-4"><span class="m-d-0 f-bold">Biaya registrasi:</span> Rp 150.000 / nomor</p>
<!--                            <p class="m-d-4"><span class="m-d-0 f-bold">Biaya registrasi:</span>-->
<!--                                <span class="f-c-red" >(Gratis)</span>-->

<!--                            </p>-->
                            <p class="m-d-0">
                                <span class="m-d-0 f-bold">Biaya langganan: </span>
                                Tersedia pilihan kuota pesan yang bisa digunakan.
                            </p>
                        </div>
                    </div>
                    <div class="p-x-20 p-y-20">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Daftar Sekarang'"
                            :id="`wa-autosender-btn-request`"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="onRegister"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOButton from "@/so-components/global/ui/SOButton";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import { moduleName } from "../store/state";

export default {
    name: "WelcomePage",
    components: {
        SOSlotBase,
        SOButton,
        SOLoadingPage,
    },
    mounted() {
        this.loadListPerangkat()
            .then((res) => {
                let { data } = res.data;
                if (data.count) {
                    this.gotoListPerangkat();
                } else {
                    this.setFormReady(true);
                }
                this.setFetching(false);
            })
            .catch((e) => {
                this.setFetching(false);
            });
    },
    data() {
        return {
            formReady: false,
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
        }),
    },
    methods: {
        ...mapActions({
            loadListPerangkat: `${moduleName}/loadListPerangkat`,
            setFetching: `${moduleName}/setFetching`,
        }),
        back() {
            this.$router.push({ name: "dashboard" });
        },
        onRegister() {
            this.$router.push({ name: "wa_autosender.register.step1" });
        },
        gotoListPerangkat() {
            this.$router.push({ name: "wa_autosender.daftar_perangkat" });
        },
        setFormReady(val) {
            this.formReady = val;
        },
    },
};
</script>
<style scoped>
.module-wa-autosender {
    background-color: #e8fcee;
}
.module-wa-autosender .header-top {
    z-index: 99 !important;
}

.module-wa-autosender .wa-autosender-content {
    background-color: white;
    height: 100vh;
}
.module-wa-autosender .wa-autosender-content .content-title {
    background-color: #e8fcee;
    width: 100vw;
    height: 200px;
    text-align: center;
    padding: 0px 20px;
}
.module-wa-autosender .wa-autosender-content .content-title div label {
    color: #40964c;
}

.module-wa-autosender .wa-autosender-content .content-title div label {
    max-width: 200px;
}

.module-wa-autosender .wa-autosender-content .biaya div {
    border: 1px solid #c8d0dd;
    padding: 12px 16px;
    border-radius: 4px;
}

@media (min-width: 325px) {
    .module-wa-autosender .wa-autosender-content .content-title {
        height: 180px;
    }
    .module-wa-autosender .wa-autosender-content .content-title div label {
        max-width: unset;
    }
}
</style>
